module.exports = __webpack_public_path__ + "static/media/Physics.9a3b54bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/subject_icons/Physics.svg
// module id = 883
// module chunks = 21